import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const Catalogs = Loadable(
  lazy(() =>
    import("./Catalogs").then(({ Catalogs }) => ({
      default: Catalogs,
    })),
  ),
);

const CatalogDetail = Loadable(
  lazy(() =>
    import("./CatalogDetail").then(({ CatalogDetail }) => ({
      default: CatalogDetail,
    })),
  ),
);

export const CatalogsRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.GenAI.Catalogs,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CATALOGS]} allowFullAccess>
        <Catalogs />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/catalogs/:uuid",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CATALOGS, ALLOWED_MODULES.CATALOG_PRODUCT]} allowFullAccess>
        <CatalogDetail />
      </AuthorizedRoute>
    ),
  },
];
